export default "__VITE_ASSET__BYm$50qY__"